import { render, staticRenderFns } from "./legal-inspect.vue?vue&type=template&id=d6dceef2&scoped=true"
import script from "./legal-inspect.vue?vue&type=script&lang=js"
export * from "./legal-inspect.vue?vue&type=script&lang=js"
import style0 from "./legal-inspect.vue?vue&type=style&index=0&id=d6dceef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6dceef2",
  null
  
)

export default component.exports